import { useLocation } from "react-router-dom";
import { useSignOut } from "src/infrastructure/auth";
import { StatusPage } from "src/components/StatusPage/StatusPage";
import { GoHomeButton } from "src/components/StatusPage/StatusPageActions";

/** Shown for any path that no module in modules.tsx registers. */
export function NotFoundPage() {
  const { pathname } = useLocation();

  return (
    <StatusPage
      code="404"
      title="Page Not Found"
      body={
        <>
          We're sorry, there's no page at <code>{pathname}</code>. It may have moved, or the link
          may be mistyped. Please go back to the home page.
        </>
      }
      actions={<GoHomeButton />}
      onSignOut={useSignOut()}
    />
  );
}
